import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ValueInput from '../value-input';
import { POSITION } from './constants';

const BoxModelValue = ({ property, position, onChange = Function.prototype }) => {
  const classes = classNames('ws-ui-box-model__section', `ws-ui-box-model__section--${position}`);

  return (
    <div className={classes}>
      <ValueInput
        fullWidth
        noBackground
        value={Number(property[position]) || 0}
        min={property.min}
        max={property.max}
        align="center"
        onChange={onChange}
      />
    </div>
  );
};

BoxModelValue.propTypes = {
  position: PropTypes.oneOf(Object.values(POSITION)).isRequired,
  property: PropTypes.shape({
    top: PropTypes.number.isRequired,
    right: PropTypes.number.isRequired,
    bottom: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func,
};

export default BoxModelValue;
